// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion {
  max-width: 1100px;
  margin: 0 auto;
  width: 90%;
  position: relative;
}

.accordion i {
  color: var(--dark);
}

iframe {
  border: 0;
}

.accordionItemHeader {
  z-index: 4;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 48px;
  border: 2px solid var(--dark);
  background-color: var(--white);
  box-shadow: var(--box-shadow);
  margin-top: -1px;
  transition: transform 0.2s ease;
}

.accordionItemHeader:hover {
  transform: scale(1.01);
}

.accordionItemHeader:nth-child(n + 2) {
  margin-top: -2px;
}

.accordionItemHeader:first-child {
  border-radius: 6px 6px 0 0 !important;
}

.accordionItemHeader:last-child {
  border-radius: 0 0 6px 6px;
  border-bottom: 2px solid var(--dark);
}

.accordionItemContent {
  position: relative;
  padding: 0;
  background-color: var(--white);
  border-left: 2px solid var(--dark);
  border-right: 2px solid var(--dark);
}
.accordionBody {
  z-index: "2";
  position: "relative";
  height: 600px;
  width: "100%";
}
.accordionBody img,
.accordionBody embed {
  height: 100%;
  width: 100%;
}
.accordionBody img {
  object-fit: cover;
}
.spin {
  animation: spin 1s ease-in-out infinite both;
}
@keyframes spin {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/Accordion.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;EACV,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAC9B,kCAAkC;EAClC,mCAAmC;AACrC;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,aAAa;AACf;AACA;;EAEE,YAAY;EACZ,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EAEE,4CAA4C;AAC9C;AAYA;EACE;IAEE,oBAAoB;EACtB;EACA;IAEE,yBAAyB;EAC3B;AACF","sourcesContent":[".accordion {\n  max-width: 1100px;\n  margin: 0 auto;\n  width: 90%;\n  position: relative;\n}\n\n.accordion i {\n  color: var(--dark);\n}\n\niframe {\n  border: 0;\n}\n\n.accordionItemHeader {\n  z-index: 4;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 48px;\n  border: 2px solid var(--dark);\n  background-color: var(--white);\n  box-shadow: var(--box-shadow);\n  margin-top: -1px;\n  transition: transform 0.2s ease;\n}\n\n.accordionItemHeader:hover {\n  transform: scale(1.01);\n}\n\n.accordionItemHeader:nth-child(n + 2) {\n  margin-top: -2px;\n}\n\n.accordionItemHeader:first-child {\n  border-radius: 6px 6px 0 0 !important;\n}\n\n.accordionItemHeader:last-child {\n  border-radius: 0 0 6px 6px;\n  border-bottom: 2px solid var(--dark);\n}\n\n.accordionItemContent {\n  position: relative;\n  padding: 0;\n  background-color: var(--white);\n  border-left: 2px solid var(--dark);\n  border-right: 2px solid var(--dark);\n}\n.accordionBody {\n  z-index: \"2\";\n  position: \"relative\";\n  height: 600px;\n  width: \"100%\";\n}\n.accordionBody img,\n.accordionBody embed {\n  height: 100%;\n  width: 100%;\n}\n.accordionBody img {\n  object-fit: cover;\n}\n.spin {\n  -webkit-animation: spin 1s ease-in-out infinite both;\n  animation: spin 1s ease-in-out infinite both;\n}\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
